
import { Component, Vue, Mixins } from "vue-property-decorator";
import {
  storeRefreshValue,
  loadRefreshValue
} from "@/services/meeting/storage";
import SoundMixin from "@/mixins/SoundMixin.vue";
import {
  sendReportAVIssue,
  sendAVReset,
  sendRetractReport
} from "@/services/meeting/messaging";
import SnackbarMixin from "./SnackbarMixin.vue";
import { IssueDetails } from "../interfaces/meeting/details";
import { filter } from "lodash";

@Component
export default class RefreshMixin extends Mixins<SoundMixin, SnackbarMixin>(
  SoundMixin,
  SnackbarMixin
) {
  displayRefreshDialog = false;
  userHasReportedIssue = false;
  issueReportedList: IssueDetails[] = [];

  get reportIssueButtonText() {
    return this.userHasReportedIssue
      ? "Retract report"
      : "Report video/audio issue";
  }

  get reportIssueColor() {
    return this.userHasReportedIssue ? "error" : "white";
  }

  get reportedIssueNames() {
    const names = this.issueReportedList.map(reportedUser => reportedUser.name);
    // Return unique users.
    return names ? Array.from(new Set(names)) : [];
  }

  get reportedIssueNamesString() {
    return this.reportedIssueNames.join(", ");
  }

  get hasReceiveIssueReport() {
    return Boolean(this.issueReportedList.length);
  }

  async reportIssue(userId: string, name: string) {
    // Display dialog if page has not been refreshed
    const refreshed = await loadRefreshValue();
    if (JSON.parse(refreshed)) {
      this.userHasReportedIssue = !this.userHasReportedIssue;
      if (this.userHasReportedIssue) {
        sendReportAVIssue({ userId, name });
      } else {
        sendRetractReport({ userId, name });
      }
      return;
    }
    this.displayRefreshDialog = true;
  }

  clearReportedIssue() {
    this.issueReportedList = [];
    sendAVReset();
  }

  async processRefresh() {
    // Refresh page and set localstorage to true
    this.displayRefreshDialog = false;
    await location.reload(true);
    storeRefreshValue("true");
  }

  onIssueReport(details: IssueDetails) {
    this.issueReportedList.push(details);
    this.playNotification();
    this.displayRefreshDialog = true;
  }

  onRetractReport(details: IssueDetails) {
    this.issueReportedList = filter(
      this.issueReportedList,
      object => object.userId !== details.userId
    );
  }

  onIssueReset() {
    this.userHasReportedIssue = false;
  }
}
